<template>
  <v-layout
    align-center
    justify-center
  >
    <v-flex
      xs12
      sm8
      md4
    >
      <v-card
        max-width="380"
        class="mx-auto"
        color="#100d2c"
      >
        <v-layout
          align-center
          justify-center
          column
          class="pt-6"
        >
          <v-img
            :src="require('@/assets/images/dimers-bright-yellow.png')"
            width="auto"
            height=" 64px"
          ></v-img>
          <!-- <div class="display-1 ma-3">DIMERS</div> -->
          <div class="subtitle-1 white--text">Sign into your account</div>
        </v-layout>
        <div class="pa-6 dark-background">
          <v-tabs
            v-model="tab"
            class="no-tab-bar"
            background-color="#100d2c"
          >
            <v-tabs-items v-model="tab">
              <v-tab-item
                value="username-tab"
                class="dark-background"
              >
                <v-form
                  ref="form"
                  @submit.prevent="checkUsername"
                  class="dark-background"
                >
                  <v-text-field
                    solo
                    clearable
                    required
                    v-model="form.username"
                    label="Email or phone number"
                    :error-messages="form.$getError('username')"
                  ></v-text-field>
                  <v-btn
                    block
                    large
                    color="primary"
                    type="submit"
                    :loading="form.$busy"
                    class="dark-background"
                  >Submit</v-btn>
                </v-form>
              </v-tab-item>
              <v-tab-item
                value="password-tab"
                class="dark-background"
              >
                <div class="text-center mb-8">
                  <div v-if="form.username">
                    <v-chip
                      close
                      @click:close="notYou"
                      outlined
                      class="white--text"
                    >
                      <v-avatar left>
                        <img
                          :src="require('@/assets/images/default-profile.png')"
                          alt
                        />
                      </v-avatar>
                      {{ form.username }}
                    </v-chip>
                  </div>
                </div>
                <v-form
                  ref="form"
                  @submit.prevent="signIn"
                >
                  <v-text-field
                    solo
                    required
                    type="password"
                    label="Password"
                    v-model="form.password"
                    :error-messages="form.$getError('password')"
                  ></v-text-field>
                  <v-btn
                    block
                    large
                    color="primary"
                    type="submit"
                    :loading="form.$busy"
                  >Sign in</v-btn>
                </v-form>
                <!-- <v-layout class="mt-4">
                  <v-btn
                    text
                    color="primary"
                    block
                    :to="{ name: 'auth.forgot-password' }"
                  >Forgot password ?</v-btn>
                </v-layout> -->
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </div>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Form from '@/utils/form'

export default {
  name: 'LoginPage',
  data () {
    return {
      tab: 'username-tab',
      form: new Form({
        username: null,
        password: null
      })
    }
  },

  methods: {
    checkUsername () {
      this.form.$clearErrors()
      this.form.$busy = true
      this.$api
        .post('auth/check-username', { username: this.form.username })
        .then(({ data }) => {
          this.form.$busy = false
          this.showPasswordTab()
        })
        .catch(err => {
          this.form.$busy = false
          if (err.response.status === 404 || err.response.status === 422) {
            this.form.$setErrors({ username: err.response.data.message })
          }
        })
    },

    async signIn () {
      this.form.$clearErrors()
      this.form.$busy = true
      await this.$api
        .post('auth/login', {
          username: this.form.username,
          password: this.form.password
        })
        .then(({ data }) => {
          if (data.data.user.role !== 'ADMIN' && data.data.user.role !== 'PUBLISHER' && data.data.user.role !== 'EDITOR') {
            this.form.$setErrors({ password: 'Unauthorized Access.' })
            this.form.$busy = false
            return false
          }

          this.form.$busy = false
          this.$store.commit('auth/setToken', data.data)
          this.$router.replace({ name: 'home' })
        })
        .catch(err => {
          this.form.$busy = false
          if (err.response.status === 401) {
            this.form.$setErrors({ password: err.response.data.message })
          }
        })
    },

    notYou () {
      this.clearForm()
    },

    showUsernameTab () {
      this.tab = 'username-tab'
    },

    showPasswordTab () {
      this.tab = 'password-tab'
    },

    clearForm () {
      this.form.$reset()
      this.showUsernameTab()
    }
  },
  watch: {
    'form.username' () {
      this.form.$clearError('username')
    },
    'form.password' () {
      this.form.$clearError('password')
    }
  }
}
</script>

<style>
.no-tab-bar .v-tabs-bar {
  height: 0 !important;
}
.dark-background {
  background: #100d2c;
}
</style>
